import { ImageLoader as NextImageLoader } from 'next/image'

// this will automatically prefix images with NEXT_PUBLIC_WEBSITE_ASSETS_CDN_URL
// https://nextjs.org/docs/api-reference/next/image#loader
// https://nextjs.org/docs/api-reference/next/image#built-in-loaders
export const ImageLoader: NextImageLoader = ({ src, width }) =>
  `${src}?tr=w-${width}`
